import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../images/invet_img.png';
var _hoisted_1 = {
  class: "invet_box"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "invet_content_box container"
};

var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "adv_right col-lg-4 col-md-12 col-sm-12"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "invest_img"
})], -1);

var _hoisted_5 = {
  class: "adv_left col-lg-8 col-md-12 col-sm-12"
};

var _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "invet_left_title"
}, "About Bain Capital", -1);

var _hoisted_7 = {
  class: "more_invest"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" Bain Capital is of the world's leading private investment firms with approximately $185 billion in assets under management that creates lasting impact for the investors, teams, businesses, and the communities which it serves. Founded in 1984, Bain Capital pioneered a consulting-based approach to private equity investing, partnering closely with management teams to build great businesses and improve operations. Over time, the firm has organically expanded this approach to deeply collaborate across asset classes and geographies, including in Asia where it has built a 20-year track record and as trusted investor and partner of choice to businesses in the region. The Bain Capital Life Sciences and Asia Private Equity teams frequently collaborate across investments in biopharmaceutical, medical device, diagnostic, and life science tool companies across the globe, with a focus on companies, such as Tenacia, that drive medical innovation to improve the lives of patients with unmet medical needs. ");

var _hoisted_9 = {
  class: "more_bain"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" For more information about Bain Capital, please visit：");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_collapse_item = _resolveComponent("el-collapse-item");

  var _component_el_collapse = _resolveComponent("el-collapse");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_collapse, {
    accordion: true,
    modelValue: $setup.activeNames,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $setup.activeNames = $event;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_collapse_item, {
        class: "article_collapse",
        name: 1
      }, {
        title: _withCtx(function () {
          return [_createElementVNode("div", {
            class: _normalizeClass(['invet_left_intro', !$setup.showMore ? 'inv_title_text_show' : 'inv_title_none'])
          }, " Bain Capital is of the world's leading private investment firms ... ", 2)];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("a", {
            class: "link_bain",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return $setup.jumpWeb('https://www.baincapital.com/about-us');
            })
          }, "https://www.baincapital.com/")])]), _createElementVNode("div", {
            class: "invet_more inv_close",
            onClick: _cache[1] || (_cache[1] = function () {
              return $setup.retract && $setup.retract.apply($setup, arguments);
            })
          })];
        }),
        _: 1
      }), !$setup.showMore ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "invet_more",
        onClick: _cache[2] || (_cache[2] = function () {
          return $setup.toggleMore && $setup.toggleMore.apply($setup, arguments);
        })
      })) : _createCommentVNode("", true)])])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}